export const getParsedData = (codes: any[], key: string, valueFilter: string, showAll: boolean) => {
  const filter = valueFilter.toUpperCase()
  let result = codes

  if (filter) {
    result = codes.filter(
      (v) =>
        (v.CodeName && ~v.CodeName.toUpperCase().indexOf(filter)) ||
        (v.Code && ~v.Code.toUpperCase().indexOf(filter)) ||
        (v[key] && ~v[key].toUpperCase().indexOf(filter))
    )
  }
  return result.slice(0, !showAll ? 5 : undefined)
}
